"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3641],{

/***/ 13641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JsonPageBuilderWidget": function() { return /* reexport */ JsonPageBuilderWidget; },
  "JsonPageBuilderWidgetWrapper": function() { return /* reexport */ JsonPageBuilderWidgetWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/index.js
var kui = __webpack_require__(15089);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/widgetDnD.module.scss
var widgetDnD_module = __webpack_require__(60373);
var widgetDnD_module_default = /*#__PURE__*/__webpack_require__.n(widgetDnD_module);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/CreateHTML.tsx + 6 modules
var CreateHTML = __webpack_require__(14564);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/components/DesignSystem/index.js + 1 modules
var DesignSystem = __webpack_require__(6449);
;// CONCATENATED MODULE: ./src/components/DesignSystem/JsonPageBuilderWidget/JsonPageBuilderWidget.tsx







// eslint-disable-next-line
var JsonPageBuilderWidgetWrapper = function() {
    var jsonTree = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.jsonWidgetsReducer.widgets;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "page-builder-view",
        className: (widgetDnD_module_default()).builderPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateHTML/* CreateHTML */.IU, {
            jsonTree: jsonTree
        })
    });
};
// const areEqual = (prevProps: JsonPageWidgetProps, nextProps: JsonPageWidgetProps) => {
//   if (prevProps.widget_id === nextProps.widget_id) {
//     return true;
//   }
//   return false;
// };
// export const JsonPageBuilderWidget = React.memo(JsonPageBuilderWidgetWrapper, areEqual);
var JsonPageBuilderWidget = JsonPageBuilderWidgetWrapper;

;// CONCATENATED MODULE: ./src/components/DesignSystem/JsonPageBuilderWidget/index.tsx



/***/ }),

/***/ 6449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/styles/registerWidgetForDnD.js
var registerWidgetForDnD = __webpack_require__(6673);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(53978);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/components/DesignSystem/registerDesignSystemWidgets.tsx










/* eslint-disable react-hooks/rules-of-hooks */ var isSerializable = function(jsonObj) {
    try {
        JSON.parse(JSON.stringify(jsonObj));
        return true;
    } catch (e) {
        return false;
    }
};
var catchJSONParse = function(jsonString) {
    if (typeof jsonString === "string") {
        var json = {};
        try {
            json = JSON.parse(jsonString);
        } catch (e) {
            console.warn("Cannot parse config props", e);
            return {};
        }
        return json;
    }
    if (isSerializable(jsonString)) {
        return jsonString;
    }
};
var getLayoutProps = function(props) {
    var config = catchJSONParse(props.config) || props.defaultConfig;
    var layout = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, catchJSONParse(props.layout)), {
        type: props.type,
        name: props.name,
        config: config
    });
    return layout;
};
var getComponent = function(props) {
    var layoutProps = getLayoutProps(props);
    var component = (0,themeImports/* getThemeComponent */.s)(props.type, props.name, layoutProps);
    if (component) {
        return component;
    }
    return null;
};
(0,_async_to_generator/* default */.Z)(function() {
    var importConfigs, requestedImports, _importConfigs, RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS, RICH_TEXT_DEFAULT_WIDGET_OPTIONS, ref, DEFAULT_CARD_FRAME_CONFIG, DEFAULT_CARD_FRAME_CONFIG_CAT, DEFAULT_LIST_ARRANGEMENT_PRESENTATION, DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT, ref1, DEFAULT_FEATURED_CATEGORY_ARRANGEMENT_PRESENTATION, DEFAULT_FEATURED_COLLECTION_ARRANGEMENT_PRESENTATION, DEFAULT_FEATURED_TAG_ARRANGEMENT_PRESENTATION, ref2, DEFAULT_MULTI_COLUMN_ICON_CARD, DEFAULT_MULTI_COLUMN_ICON_IMAGE, DEFAULT_MULTI_COLUMN_ICON_LAYOUT, ref3, DEFAULT_LOGO_SLIDER_CARD, DEFAULT_LOGO_SLIDER_LAYOUT, FOOTER_DATA, ref4, DEFAULT_INSTA_CARD_FRAME_CONFIG, DEFAULT_INSTA_LIST_ARRANGEMENT_PRESENTATION, ref5, DEFAULT_FEATURED_REEL_CARD_CONFIG, FEATURED_REELS_PRESENTATION_CONFIG, ref6, DEFAULT_BLOG_CARD, DEFAULT_BLOG_LAYOUT, ref7, TESTIMONIALS_CARD_CONFIG, TESTIMONIALS_PRESENTATION_CONFIG, ref8, DEFAULT_GALLERY_CARD_CONFIG, GALLERY_PRESENTATION_CONFIG, ref9, NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG, NEW_ANNOUNCEMENT_CARD_CONFIG, WHATS_APP_DEFAULT_VALUE, ref10, PRODUCT_TESTIMONIALS_CARD_CONFIG, PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG, registerThemeWidget, DEFAULT_CATEGORY_CONFIG;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                importConfigs = [];
                if (!(checkRenderEnv/* IS_CLIENT */.kc && window.location.pathname.includes("widgets/"))) return [
                    3,
                    2
                ];
                return [
                    4,
                    Promise.all([
                        __webpack_require__.e(/* import() */ 5386).then(__webpack_require__.bind(__webpack_require__, 5386)),
                        __webpack_require__.e(/* import() */ 3903).then(__webpack_require__.bind(__webpack_require__, 83903)),
                        __webpack_require__.e(/* import() */ 9719).then(__webpack_require__.bind(__webpack_require__, 99719)),
                        __webpack_require__.e(/* import() */ 9410).then(__webpack_require__.bind(__webpack_require__, 9410)),
                        Promise.all(/* import() */[__webpack_require__.e(2147), __webpack_require__.e(4436)]).then(__webpack_require__.bind(__webpack_require__, 42147)),
                        __webpack_require__.e(/* import() */ 1571).then(__webpack_require__.bind(__webpack_require__, 41571)),
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 77682)),
                        __webpack_require__.e(/* import() */ 4724).then(__webpack_require__.bind(__webpack_require__, 14724)),
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41568)),
                        Promise.all(/* import() */[__webpack_require__.e(2147), __webpack_require__.e(7927)]).then(__webpack_require__.bind(__webpack_require__, 11322)),
                        Promise.all(/* import() */[__webpack_require__.e(9719), __webpack_require__.e(485)]).then(__webpack_require__.bind(__webpack_require__, 90485)),
                        Promise.all(/* import() */[__webpack_require__.e(9719), __webpack_require__.e(4713)]).then(__webpack_require__.bind(__webpack_require__, 24713)),
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35789)),
                        __webpack_require__.e(/* import() */ 1100).then(__webpack_require__.bind(__webpack_require__, 21100)),
                        Promise.all(/* import() */[__webpack_require__.e(9719), __webpack_require__.e(6499)]).then(__webpack_require__.bind(__webpack_require__, 66499))
                    ]).then(function(response) {
                        return response;
                    })
                ];
            case 1:
                requestedImports = _state.sent();
                importConfigs = requestedImports;
                return [
                    3,
                    3
                ];
            case 2:
                importConfigs = new Array(15).fill({});
                _state.label = 3;
            case 3:
                _importConfigs = (0,_sliced_to_array/* default */.Z)(importConfigs, 15), RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS = _importConfigs[0].RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS, RICH_TEXT_DEFAULT_WIDGET_OPTIONS = _importConfigs[1].RICH_TEXT_DEFAULT_WIDGET_OPTIONS, ref = _importConfigs[2], DEFAULT_CARD_FRAME_CONFIG = ref.DEFAULT_CARD_FRAME_CONFIG, DEFAULT_CARD_FRAME_CONFIG_CAT = ref.DEFAULT_CARD_FRAME_CONFIG_CAT, DEFAULT_LIST_ARRANGEMENT_PRESENTATION = ref.DEFAULT_LIST_ARRANGEMENT_PRESENTATION, DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT = ref.DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT, ref1 = _importConfigs[3], DEFAULT_FEATURED_CATEGORY_ARRANGEMENT_PRESENTATION = ref1.DEFAULT_FEATURED_CATEGORY_ARRANGEMENT_PRESENTATION, DEFAULT_FEATURED_COLLECTION_ARRANGEMENT_PRESENTATION = ref1.DEFAULT_FEATURED_COLLECTION_ARRANGEMENT_PRESENTATION, DEFAULT_FEATURED_TAG_ARRANGEMENT_PRESENTATION = ref1.DEFAULT_FEATURED_TAG_ARRANGEMENT_PRESENTATION, ref2 = _importConfigs[4], DEFAULT_MULTI_COLUMN_ICON_CARD = ref2.DEFAULT_MULTI_COLUMN_ICON_CARD, DEFAULT_MULTI_COLUMN_ICON_IMAGE = ref2.DEFAULT_MULTI_COLUMN_ICON_IMAGE, DEFAULT_MULTI_COLUMN_ICON_LAYOUT = ref2.DEFAULT_MULTI_COLUMN_ICON_LAYOUT, ref3 = _importConfigs[5], DEFAULT_LOGO_SLIDER_CARD = ref3.DEFAULT_LOGO_SLIDER_CARD, DEFAULT_LOGO_SLIDER_LAYOUT = ref3.DEFAULT_LOGO_SLIDER_LAYOUT, FOOTER_DATA = _importConfigs[6].FOOTER_DATA, ref4 = _importConfigs[7], DEFAULT_INSTA_CARD_FRAME_CONFIG = ref4.DEFAULT_INSTA_CARD_FRAME_CONFIG, DEFAULT_INSTA_LIST_ARRANGEMENT_PRESENTATION = ref4.DEFAULT_INSTA_LIST_ARRANGEMENT_PRESENTATION, ref5 = _importConfigs[8], DEFAULT_FEATURED_REEL_CARD_CONFIG = ref5.DEFAULT_FEATURED_REEL_CARD_CONFIG, FEATURED_REELS_PRESENTATION_CONFIG = ref5.FEATURED_REELS_PRESENTATION_CONFIG, ref6 = _importConfigs[9], DEFAULT_BLOG_CARD = ref6.DEFAULT_BLOG_CARD, DEFAULT_BLOG_LAYOUT = ref6.DEFAULT_BLOG_LAYOUT, ref7 = _importConfigs[10], TESTIMONIALS_CARD_CONFIG = ref7.TESTIMONIALS_CARD_CONFIG, TESTIMONIALS_PRESENTATION_CONFIG = ref7.TESTIMONIALS_PRESENTATION_CONFIG, ref8 = _importConfigs[11], DEFAULT_GALLERY_CARD_CONFIG = ref8.DEFAULT_GALLERY_CARD_CONFIG, GALLERY_PRESENTATION_CONFIG = ref8.GALLERY_PRESENTATION_CONFIG, ref9 = _importConfigs[12], NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG = ref9.NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG, NEW_ANNOUNCEMENT_CARD_CONFIG = ref9.NEW_ANNOUNCEMENT_CARD_CONFIG, WHATS_APP_DEFAULT_VALUE = _importConfigs[13].WHATS_APP_DEFAULT_VALUE, ref10 = _importConfigs[14], PRODUCT_TESTIMONIALS_CARD_CONFIG = ref10.PRODUCT_TESTIMONIALS_CARD_CONFIG, PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG = ref10.PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG;
                registerThemeWidget = function(widgetData) {
                    (0,registerWidgetForDnD.registerWidget)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        icon: "horizontal_rule"
                    }, widgetData), {
                        type: "theme",
                        group: "legacy"
                    }));
                };
                registerThemeWidget({
                    name: "Header Menu",
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "Header",
                            name: "Header1"
                        }, props));
                    },
                    options: {
                        name: [
                            "Header1",
                            "Header2",
                            "Header3",
                            "Header4",
                            "Header5",
                            "Header6",
                            "Header7",
                            "Header8",
                            "Header9",
                            "Header10",
                            "Header11",
                            "Header12",
                            "Header13",
                            "Header14"
                        ],
                        config: "json",
                        "config.color_scheme.bg_color": {
                            type: "color",
                            label: "Background Color",
                            placeholder: "",
                            hint: "RGB Background Color"
                        },
                        "config.name": "",
                        "config.hidden_components.login_view": false,
                        "config.hidden_components.whatsapp_view": false,
                        "config.hidden_components.isShopDropDownEnable": false
                    },
                    icon: "menu"
                });
                registerThemeWidget({
                    name: "Offers",
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "Offers",
                            name: "PromoList1"
                        }, props));
                    },
                    options: {
                        name: [
                            "PromoList1",
                            "PromoList2",
                            "PromoList3",
                            "PromoList4",
                            "PromoList5"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "redeem"
                });
                registerThemeWidget({
                    name: "Footer",
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "Footer",
                            name: "Footer"
                        }, props));
                    },
                    options: {
                        name: [
                            "Footer",
                            "Footer1",
                            "Footer2",
                            "Footer3",
                            "Footer4"
                        ],
                        config: "json",
                        layout: "json",
                        includeCollectionSet: false,
                        noDescription: false
                    },
                    icon: "dock_to_bottom"
                });
                registerThemeWidget({
                    name: "Middle Body",
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "MiddleBody",
                            name: "MiddleBody1"
                        }, props));
                    },
                    options: {
                        name: [
                            "MiddleBody1",
                            "MiddleBody2",
                            "MiddleBody3",
                            "MiddleBody4",
                            "MiddleBody5",
                            "MiddleBody6"
                        ],
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "CategoryProductWidget",
                    options: {
                        name: [
                            "CategoryWidgetHorizontalView1",
                            "CategoryWidgetGridView1"
                        ],
                        layout: "json",
                        config: "json"
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "CategoryProductWidget",
                            name: "CategoryWidgetHorizontalView1"
                        }, props));
                    },
                    icon: "category"
                });
                registerThemeWidget({
                    name: "CollectionCategoryProductwidget",
                    options: {},
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "CollectionCategoryProductWidget",
                            name: "CollectionCategoryProductWidget1"
                        }, props));
                    },
                    icon: "list"
                });
                registerThemeWidget({
                    name: "Announcement Bar",
                    options: {},
                    component: function(props) {
                        return (0,themeImports/* getThemeComponent */.s)("HelloBar", "SubHeader", {
                            config: props.widgets && {
                                widgets: props.widgets
                            }
                        });
                    },
                    icon: "campaign"
                });
                registerThemeWidget({
                    name: "SortAndFilter",
                    options: {},
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "SortingAndFilterWidget",
                            name: "SortingAndFilterWidget1"
                        }, props));
                    },
                    icon: "sort_by_alpha"
                });
                registerThemeWidget({
                    name: "Testimonial",
                    options: {
                        max_items: 3
                    },
                    component: function(props) {
                        return getComponent({
                            type: "AdditionalPageWidget",
                            slug: "testimonial",
                            config: {
                                max_items: props.max_items || 3
                            }
                        });
                    },
                    icon: "reviews"
                });
                registerThemeWidget({
                    name: "Blog",
                    options: {
                        max_items: 2
                    },
                    component: function(props) {
                        return getComponent({
                            type: "AdditionalPageWidget",
                            slug: "blog",
                            config: {
                                max_items: props.max_items || 2
                            }
                        });
                    },
                    icon: "newspaper"
                });
                registerThemeWidget({
                    name: "Additional Page",
                    options: {
                        slug: "",
                        config: "json"
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "AdditionalPageWidget"
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: "Carousel",
                    options: {
                        name: [
                            "Carousel"
                        ]
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "Carousel"
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.HERO_BANNER.name */.Pe.HERO_BANNER.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.HERO_BANNER.type */.Pe.HERO_BANNER.type
                        ]
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.HERO_BANNER.type */.Pe.HERO_BANNER.type
                        }, props));
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "StaticWidget",
                    options: {
                        slug: "",
                        config: "json"
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: "StaticWidget"
                        }, props));
                    },
                    icon: "note_add"
                });
                DEFAULT_CATEGORY_CONFIG = {
                    animation: "pop",
                    aspect_ratio: 100,
                    card_cta_visibility: false,
                    desktop: {
                        grid: {
                            cols: 4,
                            rows: 2
                        },
                        spacing: 24
                    },
                    heading: "Categories",
                    mobile: {
                        grid: {
                            cols: 2,
                            rows: 4
                        },
                        spacing: 24
                    }
                };
                registerThemeWidget({
                    name: "Category Widget",
                    options: {
                        name: [
                            "CategoryWidget1",
                            "CategoryWidget2",
                            "CategoryWidget3",
                            "CategoryWidget4",
                            "CategoryWidget5",
                            "CategoryWidget6",
                            "CategoryWidget7",
                            "CategoryWidget8",
                            "CategoryWidget9",
                            "CategoryWidget10",
                            "CategoryWidget11",
                            "CategoryWidget12",
                            "CategoryWidget13",
                            "CategoryWidget14",
                            "CategoryWidget15",
                            "CategoryWidget16"
                        ],
                        config: "json"
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "CategoryWidget"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    icon: "category"
                });
                registerThemeWidget({
                    name: "Collection Widget",
                    options: {
                        name: [
                            "CollectionWidget1",
                            "CollectionWidget2",
                            "CollectionWidget3"
                        ],
                        config: "json"
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "CollectionWidget",
                            name: "CollectionWidget1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    icon: "collections_bookmark"
                });
                // Brand Website Component Registration
                registerThemeWidget({
                    name: "ModernHeroBanner",
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "ModernHeroBanner",
                            name: "ModernHeroBanner1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    options: {
                        name: [
                            "ModernHeroBanner1",
                            "ModernHeroBanner2",
                            "ModernHeroBanner3",
                            "ModernHeroBanner4",
                            "ModernHeroBanner5"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "ModernMiddleBodyColumn",
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "ModernMiddleBodyColumn",
                            name: "ModernMiddleBodyColumn1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    options: {
                        name: [
                            "ModernMiddleBodyColumn1",
                            "ModernMiddleBodyColumn2",
                            "ModernMiddleBodyColumn3",
                            "ModernMiddleBodyColumn4",
                            "ModernMiddleBodyColumn5",
                            "ModernMiddleBodyColumn6"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "ModernMiddleBodyGallery",
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "ModernMiddleBodyGallery",
                            name: "ModernMiddleBodyGallery1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    options: {
                        name: [
                            "ModernMiddleBodyGallery1",
                            "ModernMiddleBodyGallery2",
                            "ModernMiddleBodyGallery3",
                            "ModernMiddleBodyGallery4",
                            "ModernMiddleBodyGallery5",
                            "ModernMiddleBodyGallery6",
                            "ModernMiddleBodyGallery7",
                            "ModernMiddleBodyGallery8"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "ModernMiddleBodyTabs",
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "ModernMiddleBodyTabs",
                            name: "ModernMiddleBodyTab1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    options: {
                        name: [
                            "ModernMiddleBodyTab1",
                            "ModernMiddleBodyTab2",
                            "ModernMiddleBodyTab3"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: "ModernMiddleBodyMaps",
                    component: function(props) {
                        return getComponent((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "ModernMiddleBodyMaps",
                            name: "ModernMiddleBodyMaps1"
                        }, props), {
                            defaultConfig: DEFAULT_CATEGORY_CONFIG
                        }));
                    },
                    options: {
                        name: [
                            "ModernMiddleBodyMap1",
                            "ModernMiddleBodyMap2",
                            "ModernMiddleBodyMap3"
                        ],
                        config: "json",
                        layout: ""
                    },
                    icon: "pages"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.name */.Pe.RICH_TEXT_WITH_IMAGE.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.name */.Pe.RICH_TEXT_WITH_IMAGE.name
                        ],
                        defaultProps: cloneDeep_default()(RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS)
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.type */.Pe.RICH_TEXT_WITH_IMAGE.type,
                            name: widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.name */.Pe.RICH_TEXT_WITH_IMAGE.name,
                            defaultConfig: cloneDeep_default()(RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS)
                        }, props));
                    },
                    icon: "list"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.RICH_TEXT.name */.Pe.RICH_TEXT.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.RICH_TEXT.name */.Pe.RICH_TEXT.name
                        ],
                        defaultProps: cloneDeep_default()(RICH_TEXT_DEFAULT_WIDGET_OPTIONS)
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.RICH_TEXT.type */.Pe.RICH_TEXT.type,
                            name: widgets/* ADMIN_WIDGETS.RICH_TEXT.name */.Pe.RICH_TEXT.name,
                            defaultConfig: cloneDeep_default()(RICH_TEXT_DEFAULT_WIDGET_OPTIONS)
                        }, props));
                    },
                    icon: "list"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.SLIDESHOW.name */.Pe.SLIDESHOW.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.SLIDESHOW.name */.Pe.SLIDESHOW.name
                        ]
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.SLIDESHOW.type */.Pe.SLIDESHOW.type
                        }, props));
                    },
                    icon: "note_add"
                });
                /* These configs are passed in an object to to widget renderer in the form of: {listPresentation: {...}, cardFrame: {...}}
     
  * listPresentation: config for the whole widget covered with blue border in the image attached,
   *   excluding the items that are to be rendered inside this widget (Collections in this case)
   *   reference: https://cdn.dotpe.in/longtail/themes/8603030/huBUbNSa.webp 
  
  * cardFrame: config for the items (cards) rendered inside widget shown in the image attached,
   *  these config are applied to all items
   *  reference: https://cdn.dotpe.in/longtail/themes/8603030/ERKZEa3u.webp */ registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.COLLECTIONS.name */.Pe.COLLECTIONS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.COLLECTIONS.name */.Pe.COLLECTIONS.name
                        ],
                        defaultProps: {
                            listPresentation: cloneDeep_default()(DEFAULT_LIST_ARRANGEMENT_PRESENTATION),
                            cardFrame: cloneDeep_default()(DEFAULT_CARD_FRAME_CONFIG)
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.COLLECTIONS.type */.Pe.COLLECTIONS.type,
                            defaultConfig: {
                                listPresentation: cloneDeep_default()(DEFAULT_LIST_ARRANGEMENT_PRESENTATION),
                                cardFrame: cloneDeep_default()(DEFAULT_CARD_FRAME_CONFIG)
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.CATEGORY.name */.Pe.CATEGORY.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.CATEGORY.name */.Pe.CATEGORY.name
                        ],
                        defaultProps: {
                            listPresentation: cloneDeep_default()(DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT),
                            cardFrame: cloneDeep_default()(DEFAULT_CARD_FRAME_CONFIG_CAT)
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.CATEGORY.type */.Pe.CATEGORY.type,
                            defaultConfig: {
                                listPresentation: cloneDeep_default()(DEFAULT_LIST_ARRANGEMENT_PRESENTATION_CAT),
                                cardFrame: cloneDeep_default()(DEFAULT_CARD_FRAME_CONFIG_CAT)
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_ICON.name */.Pe.MULTI_COLUMN_WITH_ICON.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_ICON.name */.Pe.MULTI_COLUMN_WITH_ICON.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_MULTI_COLUMN_ICON_LAYOUT,
                            cardFrame: DEFAULT_MULTI_COLUMN_ICON_CARD
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_ICON.type */.Pe.MULTI_COLUMN_WITH_ICON.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_MULTI_COLUMN_ICON_LAYOUT,
                                cardFrame: DEFAULT_MULTI_COLUMN_ICON_CARD
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_IMAGE.name */.Pe.MULTI_COLUMN_WITH_IMAGE.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_IMAGE.name */.Pe.MULTI_COLUMN_WITH_IMAGE.name
                        ],
                        defaultProps: {
                            listPresentation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_MULTI_COLUMN_ICON_LAYOUT), {
                                type: "image"
                            }),
                            cardFrame: DEFAULT_MULTI_COLUMN_ICON_IMAGE
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_IMAGE.type */.Pe.MULTI_COLUMN_WITH_IMAGE.type,
                            defaultConfig: {
                                listPresentation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_MULTI_COLUMN_ICON_LAYOUT), {
                                    type: "image"
                                }),
                                cardFrame: DEFAULT_MULTI_COLUMN_ICON_IMAGE
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.FEATURED_COLLECTIONS.name */.Pe.FEATURED_COLLECTIONS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.FEATURED_COLLECTIONS.name */.Pe.FEATURED_COLLECTIONS.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_FEATURED_COLLECTION_ARRANGEMENT_PRESENTATION,
                            cardFrame: DEFAULT_CARD_FRAME_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.FEATURED_COLLECTIONS.type */.Pe.FEATURED_COLLECTIONS.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_FEATURED_COLLECTION_ARRANGEMENT_PRESENTATION,
                                cardFrame: DEFAULT_CARD_FRAME_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.name */.Pe.FEATURED_CATEGORIES.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.name */.Pe.FEATURED_CATEGORIES.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_FEATURED_CATEGORY_ARRANGEMENT_PRESENTATION,
                            cardFrame: DEFAULT_CARD_FRAME_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.type */.Pe.FEATURED_CATEGORIES.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_FEATURED_CATEGORY_ARRANGEMENT_PRESENTATION,
                                cardFrame: DEFAULT_CARD_FRAME_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.FEATURED_TAGS.name */.Pe.FEATURED_TAGS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.FEATURED_TAGS.name */.Pe.FEATURED_TAGS.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_FEATURED_TAG_ARRANGEMENT_PRESENTATION,
                            cardFrame: DEFAULT_CARD_FRAME_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.FEATURED_TAGS.type */.Pe.FEATURED_TAGS.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_FEATURED_TAG_ARRANGEMENT_PRESENTATION,
                                cardFrame: DEFAULT_CARD_FRAME_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.LOGO_SLIDER.name */.Pe.LOGO_SLIDER.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.LOGO_SLIDER.name */.Pe.LOGO_SLIDER.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_LOGO_SLIDER_LAYOUT,
                            cardFrame: DEFAULT_LOGO_SLIDER_CARD
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.LOGO_SLIDER.type */.Pe.LOGO_SLIDER.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_LOGO_SLIDER_LAYOUT,
                                cardFrame: DEFAULT_LOGO_SLIDER_CARD
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.BLOG_WIDGET.name */.Pe.BLOG_WIDGET.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.BLOG_WIDGET.name */.Pe.BLOG_WIDGET.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_BLOG_LAYOUT,
                            cardFrame: DEFAULT_BLOG_CARD
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.BLOG_WIDGET.name */.Pe.BLOG_WIDGET.name,
                            defaultConfig: {
                                listPresentation: DEFAULT_BLOG_LAYOUT,
                                cardFrame: DEFAULT_BLOG_CARD
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.FOOTER.name */.Pe.FOOTER.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.FOOTER.name */.Pe.FOOTER.name
                        ],
                        defaultProps: FOOTER_DATA
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.FOOTER.type */.Pe.FOOTER.type,
                            defaultConfig: FOOTER_DATA
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.FEATURED_REELS.name */.Pe.FEATURED_REELS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.FEATURED_REELS.name */.Pe.FEATURED_REELS.name
                        ],
                        defaultProps: {
                            listPresentation: FEATURED_REELS_PRESENTATION_CONFIG,
                            cardFrame: DEFAULT_FEATURED_REEL_CARD_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.FEATURED_REELS.type */.Pe.FEATURED_REELS.type,
                            defaultConfig: {
                                listPresentation: FEATURED_REELS_PRESENTATION_CONFIG,
                                cardFrame: DEFAULT_FEATURED_REEL_CARD_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.INSTAGRAM_REELS.name */.Pe.INSTAGRAM_REELS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.INSTAGRAM_REELS.name */.Pe.INSTAGRAM_REELS.name
                        ],
                        defaultProps: {
                            listPresentation: DEFAULT_INSTA_LIST_ARRANGEMENT_PRESENTATION,
                            cardFrame: DEFAULT_INSTA_CARD_FRAME_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.INSTAGRAM_REELS.type */.Pe.INSTAGRAM_REELS.type,
                            defaultConfig: {
                                listPresentation: DEFAULT_INSTA_LIST_ARRANGEMENT_PRESENTATION,
                                cardFrame: DEFAULT_INSTA_CARD_FRAME_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.TESTIMONIALS.name */.Pe.TESTIMONIALS.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.TESTIMONIALS.name */.Pe.TESTIMONIALS.name
                        ],
                        defaultProps: {
                            listPresentation: TESTIMONIALS_PRESENTATION_CONFIG,
                            cardFrame: TESTIMONIALS_CARD_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.TESTIMONIALS.type */.Pe.TESTIMONIALS.type,
                            defaultConfig: {
                                listPresentation: TESTIMONIALS_PRESENTATION_CONFIG,
                                cardFrame: TESTIMONIALS_CARD_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.GALLERY.name */.Pe.GALLERY.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.GALLERY.name */.Pe.GALLERY.name
                        ],
                        defaultProps: {
                            listPresentation: GALLERY_PRESENTATION_CONFIG,
                            cardFrame: DEFAULT_GALLERY_CARD_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.GALLERY.type */.Pe.GALLERY.type,
                            defaultConfig: {
                                listPresentation: GALLERY_PRESENTATION_CONFIG,
                                cardFrame: DEFAULT_GALLERY_CARD_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.type */.Pe.NEW_ANNOUNCEMENT_BAR.type,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.name */.Pe.NEW_ANNOUNCEMENT_BAR.name
                        ],
                        defaultProps: {
                            listPresentation: NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG,
                            cardFrame: NEW_ANNOUNCEMENT_CARD_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.type */.Pe.NEW_ANNOUNCEMENT_BAR.type,
                            defaultConfig: {
                                listPresentation: NEW_ANNOUNCEMENT_BAR_PRESENTATION_CONFIG,
                                cardFrame: NEW_ANNOUNCEMENT_CARD_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.name */.Pe.WHATSAPP_FLOATING_ICON.name,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.name */.Pe.WHATSAPP_FLOATING_ICON.name
                        ],
                        defaultProps: WHATS_APP_DEFAULT_VALUE
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.type */.Pe.WHATSAPP_FLOATING_ICON.type,
                            name: widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.name */.Pe.WHATSAPP_FLOATING_ICON.name,
                            defaultConfig: WHATS_APP_DEFAULT_VALUE
                        }, props));
                    },
                    icon: "note_add"
                });
                registerThemeWidget({
                    name: widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type,
                    options: {
                        name: [
                            widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.name */.Pe.PRODUCT_TESTIMONIALS.name
                        ],
                        defaultProps: {
                            listPresentation: PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG,
                            cardFrame: PRODUCT_TESTIMONIALS_CARD_CONFIG
                        }
                    },
                    component: function(props) {
                        return getComponent((0,_object_spread/* default */.Z)({
                            type: widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type,
                            defaultConfig: {
                                listPresentation: PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG,
                                cardFrame: PRODUCT_TESTIMONIALS_CARD_CONFIG
                            }
                        }, props));
                    },
                    icon: "note_add"
                });
                return [
                    2
                ];
        }
    });
// registerThemeWidget({
//   name: 'Test Widget',
//   component: props => {
//     // eslint-disable-next-line no-unused-vars
//     const { children, ...restProps } = props;
//     return (
//       <>
//         Test Widget
//         <h4>Raw Props</h4>
//         <pre>{JSON.stringify(restProps, null, 2)}</pre>
//         <h4>Layout Props</h4>
//         <pre>{JSON.stringify(getLayoutProps(restProps), null, 2)}</pre>
//       </>
//     );
//   },
//   options: {
//     config: 'json',
//     layout: 'json',
//     wysiwyg: 'wysiwyg',
//     html: 'html',
//     isChecked: false,
//     testimonials: [
//       {
//         name: '',
//         title: '',
//         image: '',
//         content: 'wysiwyg',
//       },
//     ],
//   },
//   icon: 'block',
// });
})();

;// CONCATENATED MODULE: ./src/components/DesignSystem/index.js



/***/ })

}]);